import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/kobak-logo.png")